module.exports = __webpack_public_path__ + "img/permissions-instruction.a6c0beef.png";